<template lang='pug'> 
  form.forms.customers.new.component( @submit.prevent='add_customer' )
    template(v-if='msg')
      .system-msg 
        p {{ msg }}
        .close( @click='msg = ""' )
          close-icon
    template(v-else)
      label {{$t("Name")}}
      bf-input.basic
        input(v-model='customer.name' type='text' required)
      labek {{$t("Email Address")}}
      bf-input.basic
        input(v-model='customer.email' type='email')
      label {{$t("Your message")}}
      textarea(v-model='customer.invitation.message')

      bf-flex.form-buttons.space-between
        bf-button.full.clear(type='submit' @click.native='customer.invitation.invited = false')
          template(v-slot:text) {{ $t('Save') }}
        bf-button.full(type='submit' @click.native='customer.invitation.invited = true')
          //bf-button.inactive
          template(v-slot:text) {{ $t('Save and Send Invitation') }}
      
</template>

<script>
  import { db } from '@/main'

  export default {
    name: 'new-customer.form.component',

    props: {
      account: { required: true },
      biz: { required: true },
      customers: { required: true }
    },

    data() {
      return {
        msg: '',
        customer: { invitation: {invited: false, message: ''}, phone: '', email: '' },
      }
    },

    created() {
      if ( this.account.latest && this.account.latest.invitation ) this.customer.invitation.message = this.account.latest.invitation.message
    },

    methods: {
      notify(msg) {
        this.msg = msg
      },

      save(account, msg) {
        db.collection( 'accounts' ).doc( this.account.id ).update({ 
          latest: {
            ...this.account.latest,
            ...{ invitation: this.customer.invitation }
          }
        })
        db.collection( 'customers' ).doc( `${this.biz.id}->${this.customer.email}` ).set({
          ...this.customer,
          ...{
            business: {name: this.biz.name},
            business_id: this.biz.id,
            account: account ? account.data() : {},
            account_id: account ? account.id : ''
          }
        }).then( () => {
          this.notify(msg)
        })
      },

      async add_customer() {
        let snaps = await db.collection('accounts').where( 'email', '==', this.customer.email ).get()
        if ( snaps.empty ) { // account with customer's email DOES NOT exist
          if ( this.customers.some( c => c.email == this.customer.email ) ) {
            this.notify(`${this.customer.email}` + ' ' + this.$t("already invited but has not yet joined BlueFaucet") )
          }
          else {
            this.save(
              false,
              this.$t("Invitation has been sent to") + ' ' + `${this.customer.email}`
            )
          }
        }
        else { // account with customer's email already exists
          this.customer.invitation.joined = true
          if ( this.customers.some( c => c.email == this.customer.email ) ) {
            this.notify(`${this.customer.email}` + ' ' + this.$t("already exist") )
          }
          else {
            this.save(
              snaps.docs[0],
              `${this.customer.email}` + ' ' + this.$t("exists and has been added as a customer")
            )
          }
        }
      }
    }
  }
</script>

<style lang="stylus">
  textarea
    border solid 1px rgba(0 0 0 0.1)
    border-radius 5px
    padding 8px
    margin-bottom 10px
    width 97.5%
  .customers
    .bf-input
      margin-bottom 10px
    .system-msg
      font-size 1.2em
      background rgba( 240 160 100 .1 )
      padding 12px
      position relative
      .close
        cursor pointer
        position absolute
        top -10px
        right -8px
        font-size 1.2em
  
</style>
